function onClickSetMyStore(e) {
    e.preventDefault();
    var $this = $(this);
    var storeId = $this.attr('data-storeid');
    var storeName = $this.attr('data-store-name');
    var lang = $this.attr('language');
    var url = '/stores/my-store/' + storeId;
    pushDataLayerStoreClick('carte-en-faire-mon-magasin');
    pushDataLayerSetFavoriteStore(storeName);
    return changeStore(storeId, url, false, lang);
}

function changeStore(storeId, url, userConfirmation, lang) {
    var $body = $("body");
    TINK.inProgress($body);

    if (userConfirmation === undefined) {
        userConfirmation = false;
    }

    $.ajax({
        type: "POST",
        url: url,
        data: {userConfirmation: userConfirmation, lang: lang},
        success: function() {
            TINK.deleteCookies("hide-store-banner", "geolocation-confirm");
            //set localStorage to handle login popup appearance
            window.localStorage.setItem("fromChangeStoreBanner", "true");
            location.reload();
        },
        error: function(jqXHR) {
            if (!TINK.redirectIfConflict(jqXHR)) {
                TINK.stopProgress($body);
                if (jqXHR.status == 400) {
                    if(jqXHR.responseText != undefined && jqXHR.responseText) {
                        var jsonResponseValue = jQuery.parseJSON(jqXHR.responseText);
                        return requestUserConfirmation(storeId, url, jsonResponseValue.storeProvince);
                    } else {
                        location.reload();
                    }
                } else {
                    location.reload();
                }
            }
        }
    });
}

function requestUserConfirmation(storeId, url, storeProvince) {

    var textProvince = $('#storeProvince');
    textProvince.text(storeProvince);

    var options = {
        href: '#storeChangeConfirmation'
    };

    TINK.showPopUp(options)
        .then(function () {
            var button = $('#confirmChangeStore');
            button.data('storeId', storeId);
            button.data('url', url);

            $('#storeChangeConfirmation')
                .find('.focusable')
                .attr('tabindex', '0')
                .focus();
        });
}

$('#confirmChangeStore').click(function (e) {
    var storeId = $(this).data('storeId');
    var url = $(this).data('url');
    changeStore(storeId, url, true);
    return false;
});

$('#cancelChangeStore').click(function () {
    $.fancybox.close();
    return false;
});
